module.exports = __webpack_public_path__ + "img/domain-living.36c27a01.svg";